document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.product-background__widget').forEach((widget) => {
    const widgetMain = widget.querySelector('.product-widget__main'),
      widgetHeader = widget.querySelector('.product-widget__header-wrapper'),
      widgetImages = widgetMain.querySelectorAll('.product-widget__images img'),
      widgetArrows = widgetHeader.querySelectorAll('svg.product-widget__arrow'),
      colors = widgetMain.querySelectorAll('.product-widget__colors input'),
      button = widgetMain.querySelector('.button'),
      sectionals = widgetMain.querySelector('.product-widget__colors').dataset.sectionals,
      json = document.getElementById(widgetMain.querySelector('.product-widget__colors').dataset.json),
      data = JSON.parse(json.textContent);
    let selectedValue = colors[0].value,
      selectedColor = colors[0].dataset.name;
    (updateDisplayedImages(),
      colors.forEach((color) => {
        color.addEventListener('change', function () {
          ((selectedValue = color.value), (selectedColor = color.dataset.name), updateDisplayedImages());
        });
      }),
      widgetHeader.addEventListener('mouseover', function () {
        widget.classList.add('hovered');
      }),
      widgetMain.addEventListener('mouseover', function () {
        widget.classList.add('hovered');
      }),
      widget.addEventListener('mouseout', function (event) {
        widget.contains(event.relatedTarget) || widget.classList.remove('hovered');
      }));
    function updateDisplayedImages() {
      widgetImages.forEach((image) => {
        image.style.display = image.classList.contains(selectedValue) ? 'block' : 'none';
      });
      const variantURL =
        button.dataset.href + '?variant=' + getVariantId(selectedColor + ' / ' + sectionals + ' / Smart');
      ((button.href = variantURL),
        widgetArrows.forEach((arrow) => {
          arrow.onclick = () => {
            window.location.href = variantURL;
          };
        }));
    }
    function getVariantId(variantName) {
      return data.variants.find((variant) => variant.title.toString() === variantName.toString()).id;
    }
    updateDisplayedImages();
  });
});
//# sourceMappingURL=/s/files/1/0636/0265/5480/t/58/assets/section-product-background.js.map?v=1725538304
